export const visit = (vm, at) => {
at({ "de": { "hc-0133": { "sample-data-banner": { "title": "Modus mit Beispieldaten", "description": "Sie k\xF6nnen diese Daten analysieren und bearbeiten, bis Sie in der Lage sind, Ihre eigenen hochzuladen." } } } });
};